/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Registr informací o typech médií pro standardní webové technologie.
 * Podporuje všechny obrázky, videa a weby.
 * @implements {ViewerRegistry}
 * @memberof AdapterWeb
 */
class ViewerRegistry {
  /**
   * Vytvoří instanci.
   * @param {Class.<MediumRegistry>} MediumRegistry Konstruktror registru médií.
   * @param {ViewerType} imageType Záznam registru pro obrázky.
   * @param {ViewerType} kioskType Záznam registru pro kiosky.
   * @param {ViewerType} pdfType Záznam registru pro Pdf.
   * @param {ViewerType} streamType Záznam registru pro stream.
   * @param {ViewerType} videoType Záznam registru pro videa.
   * @param {ViewerType} webType Záznam registru pro web.
   */
  constructor(
    MediumRegistry,
    imageType,
    kioskType,
    pdfType,
    streamType,
    videoType,
    webType
  ) {
    // Vytvoření nového registru.
    const mediumRegistry = new MediumRegistry();
    // Registrace záznamů registru.
    mediumRegistry.register('image/*', imageType);
    mediumRegistry.register('application/pdf', pdfType);
    mediumRegistry.register('application/x-http-stream', streamType);
    mediumRegistry.register('application/x-kiwi-kiosk-1', kioskType);
    mediumRegistry.register('video/*', videoType);
    mediumRegistry.register('text/html', webType);
    this.mediumRegistry = mediumRegistry;
  }

  /** @inheritdoc */
  find(mediumType) {
    return this.mediumRegistry.find(mediumType);
  }

  /** @inheritdoc */
  getAll() {
    return this.mediumRegistry.getAll();
  }
}

export default ViewerRegistry;
